import React, { useEffect } from 'react'
import { runSaga } from 'store/sagaMiddleware'
import { init, stop } from 'store/sagas'
import Loader from 'components/Loader'
import { UserPresenceProvider } from 'components/UserPresenceProvider'
import HeartbeatsProvider from 'components/HeartbeatsProvider'
import SortableProvider from 'components/Sortable/SortableProvider'
import { KanBoProvider } from 'components/KanBoProvider/KanBoProvider'
import classes from './KanBo.module.scss'
import HomeDataProvider from 'dataProviders/Home'
import { useSelector } from 'react-redux'
import LangProvider from './LangProvider'
import { UsersNotInBoardProvider } from 'components/UsersNotInBoardProvider'
import { UserProvider } from 'components/UserProvider'
import { CardViewProvider } from 'components/CardViewProvider'
import { DocumentListItemProvider } from 'components/DocumentListItemProvider'

const KanBo: React.FC = ({
  children,
}) => {
  const isLoading = useSelector<any, boolean>(state => state.kanbo.layout.isLoading)
  const isLoaded = useSelector<any, boolean>(state => state.kanbo.layout.isLoaded)
  const userStateTrackingDisabled = useSelector<any, boolean>(state => !state.kanbo.config.heartbeats || !state.kanbo.config.heartbeats.UserStateTracking)

  useEffect(() => {
    if (!isLoading && !isLoaded) {
      runSaga(init)
    }
  }, [isLoading, isLoaded])

  useEffect(() => {
    return () => {
      runSaga(stop)
    }
  }, [])

  return (
    <>
      <LangProvider />
      {!isLoaded ? (
        <div className={classes.splashScreenWrapper}>
          <div className={classes.splashScreen}>
            <img src='/plugins/branding/logo.png' className={classes.logo} />
            <img src='/plugins/branding/title.png' className={classes.logo} />
            <Loader center />
          </div>
        </div>
      ) : (
        <>
          {userStateTrackingDisabled && <HeartbeatsProvider />}
          <HomeDataProvider />
          <KanBoProvider>
            <CardViewProvider>
              <UserProvider>
                <UserPresenceProvider>
                  <UsersNotInBoardProvider>
                    <DocumentListItemProvider>
                      <SortableProvider>
                        {children}
                      </SortableProvider>
                    </DocumentListItemProvider>
                  </UsersNotInBoardProvider>
                </UserPresenceProvider>
              </UserProvider>
            </CardViewProvider>
          </KanBoProvider>
        </>
      )}
    </>
  )
}

export default KanBo